module.exports = {"closeButtonText":"關閉","thumbNailAlt":"預覽圖片","next":"下一頁","previous":"上一頁","addNote":"新增筆記..."}


//////////////////
// WEBPACK FOOTER
// ./translations/zh-Hant.json
// module id = 40
// module chunks = 0